import { PermissionStatus } from 'expo-location';

import {
  LOCATION_PRIMER_SUPPRESSION_FOREVER,
  LOCATION_PRIMER_SUPPRESSION_STORAGE_KEY,
} from '../permissions.machine.constants';
import { permissionsStorage } from '../permissions.machine.storage';
import { type Guard, type LocationPermissionStatus } from '../permissions.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const checkIfSuppressedForever: Guard = () =>
  readSuppressedUntil() === LOCATION_PRIMER_SUPPRESSION_FOREVER;

export const checkIfSuppressionActive: Guard = () => readSuppressedUntil() > Date.now();

export const checkIfLocationPermissionGranted: Guard<LocationPermissionStatus> = (
  _args,
  params,
): boolean => params.status === PermissionStatus.GRANTED;

export const checkIfLocationPermissionDenied: Guard<LocationPermissionStatus> = (
  _args,
  params,
): boolean => params.status === PermissionStatus.DENIED;

// ─── Helpers ─────────────────────────────────────────────────────────────────

function readSuppressedUntil() {
  return permissionsStorage.getNumber(LOCATION_PRIMER_SUPPRESSION_STORAGE_KEY) ?? 0;
}
